import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { projectStatusList } from '@/module/Author/Project';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type ProjectStatusSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

export function ProjectStatusSelectControl<T extends FieldValues>(props: ProjectStatusSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(() => projectStatusList.map(c => ({ value: c, label: t(`projects.statusEnum.${c}`) })), [t]);

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
